// extracted by mini-css-extract-plugin
export default {"styledScreen":"likedScreen_styledScreen__5wcPA","styledTitle":"likedScreen_styledTitle__mrIY0"};